<template>

  <v-container
    fill-height
    fluid
  >
      <v-overlay :absolute="false" :value="!iframe.loaded">
          <v-alert>EM CONSTRUÇÃO &nbsp;&nbsp; <v-progress-circular indeterminate></v-progress-circular></v-alert>
      </v-overlay>

    <v-row
      align="center"
      justify="center"
    >

      <v-col cols="12">

        <material-card
                color="primary"
        >
            <template v-slot:header>
                <div class="px-3">

                    <div class="title font-weight-bold mb-2">
                        Painel PDI/PPI em construção
                    </div>
                    <div class="category font-weight-thin">
                        O painel de análise desse indicador ainda está em construção.
                        Você pode verificar todos indicadores em 
                        <a
                                class="white--text"
                                href="https://proplan.ufms.br/indicadores-do-pdi-ppi/"
                                target="_blank"
                        >
                            Indicadores do Plano de Desenvolvimento Institucional (PDI) Integrado ao Projeto Pedagógico Institucional (PPI) / 2020 – 2024
                        </a>
                    </div>
                </div>
            </template>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
      components: {
          MaterialCard: () => import('../components/material/Card'),
          MaterialStatsCard: () => import('../components/material/StatsCard')
      },
      data: () => ({
          iframe: {
              src: '',
              loaded: false,
              height: null,
              width: '100%',
              originalWidth: 1280,
            originalHeight: 1500,
              autoResize: {
                  active: true,
                  timeout: 700,
                  timer: null
              },
          },
      }),
      mounted() {
          // Quando o componente for montado, mostre o overlay
          this.overlayVisible = true;

          // Definir um timer de 5 segundos para esconder o overlay
          setTimeout(() => {
              this.overlayVisible = false;
          }, 5000); // 5000 milissegundos (5 segundos)
      },
      beforeDestroy() {
          if(this.iframe.autoResize.timer) {
              clearInterval(this.iframe.autoResize.timer);
          }
      },
      methods: {
          loaded: function(){
              if(this.iframe.autoResize.active) {
                  this.iFrameResize();
                  this.iframe.autoResize.timer =
                      setInterval(this.iFrameResize, this.iframe.autoResize.timeout);
              }

              setTimeout(() => { this.iframe.loaded = true }, 1000); // delay
          },

          iFrameResize() {
              if(!this.$refs.frameGrad) {
                  return;
              }

              let parentWidth = this.$refs.frameGrad.parentElement.clientWidth;
              let ratio = this.iframe.originalHeight / this.iframe.originalWidth;
              this.iframe.height = parseInt(ratio * parentWidth) + 'px';
              this.iframe.width = '100%';
          }
      }
  }
</script>

<style lang="scss">
  .tim-note {
    bottom: 10px;
    color: #c0c1c2;
    display: block;
    font-weight: 400;
    font-size: 13px;
    line-height: 13px;
    left: 0;
    margin-left: 20px;
    width: 260px;
  }
</style>
